module.exports = __webpack_public_path__ + "3162d319bb1331fffa8ee715c7cf30b1.svg";